var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-bar",on:{"click":_vm.select}},[_c('span',[_vm._v(" 年份 "+_vm._s(_vm.year)+" "),_c('i',{staticClass:"caret"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }